<template>
  <div class="myrecipe-formstep-card rsf-card-interaction-animation bg-color-white flex flex-column justify-between pointer" @click="setActiveStep(card.nextStep); setFormData(card.formDataAttribute, card)">
    <div class="option-card-flex">
      <img :src="card.goal_s3path"/>
      <div class="">
        <h3 class="h3 helvetica-bold mb1 mt3 px3 center">{{ card.optionname }}</h3>
        <div :class="`color-14 p open-sans-regular mb2 px3 center mb2`">
          <p class="h5 open-sans-bold center color-black">{{ $t('rsf_recipe_growth_rate') }}: <span class="open-sans-regular color-14">{{ card.growth }}</span></p>
          <p class="h5 open-sans-bold center color-black">{{ $t('rsf_recipe_coloration') }}: <span class="open-sans-regular color-14">{{ card.color }}</span></p>
        </div>
      </div>
    </div>
    <div class="hide lg-block">
      <div class="col-12 h1px bg-color-12 mb1 px3 border-box" style="background-clip: content-box;"></div>
      <div class="flex items-center mb3 gap1 justify-center relative">
          <p class="color-13 h5 open-sans-regular">
            {{ card.requiredMaintenance }} {{ $t('myrecipe_hours_per_week')}}
          </p>
          <div ref="tooltip-icon" class="pointer" style="transform: translateY(2px)" @mouseover="calcTooltipTipPosition(); !permanentTooltip ? showTooltip = true : ''" @mouseleave="showTooltip = false" @click.stop="permanentTooltip = !permanentTooltip">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15.5C9.9946 15.5 11.8073 14.7214 13.1509 13.4515C14.5974 12.0843 15.5 10.1475 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z" stroke="#555D65"/>
              <mask id="path-2-inside-1_1922_38284" fill="white">
              <path d="M7.48758 8.9037V8.59195C7.48758 8.32232 7.54516 8.0878 7.66031 7.88839C7.77547 7.68898 7.98611 7.47693 8.29225 7.25224C8.58715 7.0416 8.78165 6.87027 8.87574 6.73827C8.96983 6.60626 9.01687 6.45881 9.01687 6.29591C9.01687 6.11335 8.94946 5.97433 8.81465 5.87883C8.67984 5.78334 8.49166 5.73559 8.25012 5.73559C7.82883 5.73559 7.34856 5.87321 6.8093 6.14846L6.3501 5.22583C6.97642 4.87475 7.64065 4.69922 8.3428 4.69922C8.92138 4.69922 9.38128 4.83824 9.72253 5.1163C10.0638 5.39435 10.2344 5.76508 10.2344 6.22851C10.2344 6.53745 10.1642 6.80427 10.0238 7.02896C9.88332 7.25365 9.61651 7.50642 9.2233 7.78728C8.95367 7.98669 8.78305 8.13836 8.71143 8.24228C8.63981 8.34619 8.604 8.48241 8.604 8.65093V8.9037H7.48758Z"/>
              </mask>
              <path d="M7.48758 8.9037H5.48758V10.9037H7.48758V8.9037ZM8.29225 7.25224L7.12977 5.62478L7.11928 5.63227L7.10888 5.6399L8.29225 7.25224ZM6.8093 6.14846L5.01882 7.03962L5.91904 8.84833L7.71855 7.92983L6.8093 6.14846ZM6.3501 5.22583L5.37218 3.48122L3.71115 4.41229L4.55961 6.11699L6.3501 5.22583ZM9.2233 7.78728L8.06083 6.15981L8.04736 6.16944L8.03405 6.17928L9.2233 7.78728ZM8.604 8.9037V10.9037H10.604V8.9037H8.604ZM9.48758 8.9037V8.59195H5.48758V8.9037H9.48758ZM9.48758 8.59195C9.48758 8.61293 9.48069 8.73543 9.39228 8.88854L5.92835 6.88824C5.60963 7.44017 5.48758 8.03171 5.48758 8.59195H9.48758ZM9.39228 8.88854C9.36618 8.93373 9.34413 8.9634 9.33257 8.978C9.32092 8.99271 9.3166 8.99631 9.32357 8.9893C9.3304 8.98243 9.34559 8.96785 9.3715 8.94595C9.3973 8.92414 9.43153 8.89694 9.47562 8.86458L7.10888 5.6399C6.70616 5.93548 6.24345 6.34258 5.92835 6.88824L9.39228 8.88854ZM9.45473 8.87971C9.76285 8.65962 10.2009 8.3249 10.5044 7.8991L7.2471 5.57743C7.29133 5.51538 7.32612 5.47789 7.33735 5.46609C7.34997 5.45282 7.35172 5.45229 7.33731 5.46498C7.32352 5.47713 7.29988 5.49704 7.26406 5.525C7.22853 5.55273 7.18415 5.58593 7.12977 5.62478L9.45473 8.87971ZM10.5044 7.8991C10.8413 7.42643 11.0169 6.87278 11.0169 6.29591H7.01687C7.01687 6.18194 7.0338 6.05369 7.07621 5.92077C7.11865 5.78775 7.17953 5.67223 7.2471 5.57743L10.5044 7.8991ZM11.0169 6.29591C11.0169 5.54403 10.6965 4.76088 9.97068 4.24678L7.65862 7.51088C7.47056 7.37767 7.29023 7.18208 7.16669 6.92727C7.04666 6.67972 7.01687 6.45242 7.01687 6.29591H11.0169ZM9.97068 4.24678C9.37452 3.8245 8.7233 3.73559 8.25012 3.73559V7.73559C8.24352 7.73559 8.18069 7.73539 8.08053 7.70998C7.97722 7.68376 7.82368 7.6278 7.65862 7.51088L9.97068 4.24678ZM8.25012 3.73559C7.40515 3.73559 6.60618 4.00668 5.90006 4.36709L7.71855 7.92983C8.09094 7.73975 8.2525 7.73559 8.25012 7.73559V3.73559ZM8.59979 5.2573L8.14058 4.33468L4.55961 6.11699L5.01882 7.03962L8.59979 5.2573ZM7.32802 6.97044C7.66266 6.78287 7.9911 6.69922 8.3428 6.69922V2.69922C7.2902 2.69922 6.29018 2.96664 5.37218 3.48122L7.32802 6.97044ZM8.3428 6.69922C8.47466 6.69922 8.53437 6.71534 8.54295 6.71793C8.5464 6.71897 8.53776 6.71665 8.52081 6.70782C8.50351 6.69882 8.48196 6.68532 8.45919 6.66677L10.9859 3.56583C10.189 2.91656 9.23575 2.69922 8.3428 2.69922V6.69922ZM8.45919 6.66677C8.4122 6.62848 8.34172 6.55228 8.28961 6.43904C8.23887 6.32879 8.2344 6.24631 8.2344 6.22851H12.2344C12.2344 5.20033 11.8209 4.24618 10.9859 3.56583L8.45919 6.66677ZM8.2344 6.22851C8.2344 6.23141 8.23412 6.20254 8.24759 6.15134C8.26157 6.09823 8.28698 6.03421 8.32776 5.96896L11.7198 8.08896C12.0899 7.49669 12.2344 6.849 12.2344 6.22851H8.2344ZM8.32776 5.96896C8.37443 5.89428 8.39688 5.88394 8.34283 5.93515C8.29331 5.98207 8.20431 6.05732 8.06083 6.15981L10.3858 9.41475C10.8458 9.08619 11.3692 8.6498 11.7198 8.08896L8.32776 5.96896ZM8.03405 6.17928C7.78772 6.36146 7.35108 6.69173 7.06465 7.10733L10.3582 9.37722C10.3272 9.42227 10.2999 9.45677 10.2805 9.48006C10.2608 9.50373 10.2451 9.5209 10.2353 9.5312C10.2254 9.5417 10.219 9.54788 10.2172 9.54953C10.2154 9.55127 10.2167 9.54995 10.2218 9.54541C10.2326 9.53586 10.2533 9.51812 10.2866 9.49157C10.3195 9.46533 10.3611 9.43334 10.4126 9.39529L8.03405 6.17928ZM7.06465 7.10733C6.69733 7.6403 6.604 8.21063 6.604 8.65093H10.604C10.604 8.75419 10.5823 9.05209 10.3582 9.37722L7.06465 7.10733ZM6.604 8.65093V8.9037H10.604V8.65093H6.604ZM8.604 6.9037H7.48758V10.9037H8.604V6.9037Z" fill="#555D65" mask="url(#path-2-inside-1_1922_38284)"/>
              <circle cx="8.06852" cy="10.3459" r="0.715" fill="#555D65"/>
            </svg>
          </div>
          <div :class="`col-12 tooltip-bubble ${showTooltip || permanentTooltip ? 'active' : ''}`" @mouseover="showTooltip = true"  @mouseleave="showTooltip = false">
            <div ref="tooltip-tip" class="tooltip-tip"></div>
            <p class="h6 open-sans-regular">
              {{ $t('myrecipe_objective_card_tooltip') }}
            </p>
          </div>
      </div>
    </div>
    <div class="rsf-btn rsf-btn-primary color-white bg-color-1 mx-auto hide lg-block" style="min-width: 0;" @click.stop="setActiveStep(card.nextStep); setFormData(card.formDataAttribute, card)">{{$t('rsf_btn_label_select')}}</div>
  </div>
</template>

<script>

export default {
  name: 'Card_Option',
  props: {
    card: Object,
    setActiveStep: Function,
    setFormData: Function
  },
  data(){
    return {
      showTooltip: false,
      permanentTooltip: false
    }
  },
  methods: {
    calcTooltipTipPosition(){
      this.$refs['tooltip-tip'].style.left = (this.$refs['tooltip-icon'].offsetLeft - 10) + 'px'
    }
  }
}
</script>
<style scoped>
  .myrecipe-formstep-card{
    padding-top: 1.5rem;
    padding-bottom: 2rem;
    width: 262px;
    box-sizing: border-box;
    flex-shrink: 0;
    border: 1px solid var(--rsf-2022-color-12);
    border-radius: 8px;
  }
  .myrecipe-formstep-card img{
    width: 120px;
    aspect-ratio: 1 / 1; 
    object-fit: contain; 
    display: block;
    margin: 0 auto;
  }
  .tooltip-bubble{
    position: absolute; 
    bottom: -1rem;
    right: 0;
    border: 1px solid var(--rsf-2022-color-12);
    box-sizing: border-box;
    padding: 1rem;
    padding-top: .75rem;
    background-color: white;
    transition: .3s ease; 
    opacity: 0; 
    transform: translateY(150%); 
    transition-delay: .3s;
    visibility: hidden;
    border-radius: 8px;
  }

  .tooltip-bubble.active{
    opacity: 1; 
    transform: translateY(100%); 
    pointer-events: all;
    visibility: visible;
  }
  .tooltip-tip{
    position: absolute; 
    top: -1px; 
    left: 2rem;
    height: 20px;
    aspect-ratio: 1 / 1; 
    border-radius: 4px;
    background-color: white;
    transform: rotate(45deg) translateY(-50%);
    box-shadow: -0.75px -0.75px 0 0 var(--rsf-2022-color-12);
  }

  @media(max-width: 1024px){
    .mobile-cards .option-card-flex{
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }

    .mobile-cards .option-card-flex h3{
      margin-top: 0;
      text-align: left; 
    }
    .mobile-cards .option-card-flex p{
      margin-bottom: 0;
      text-align: left; 
      font-family: 'Open Sans Regular' !important;
      color: var(--rsf-2022-color-14);
    }
    .mobile-cards .myrecipe-formstep-card{
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
      padding: 1rem 0;
    }
    .mobile-cards .myrecipe-formstep-card .rsf-btn{
      display: none;
    }
    .mobile-cards .myrecipe-formstep-card img{
      margin: 0;
      padding-right: 1rem
    }
    .mobile-cards .myrecipe-formstep-card .flex.lg-flex-column.flex-row-reverse{ 
      gap: 2rem;
    } 
  }
</style>